// Distinguishes which backend a document/receipt came from, so a shared viewer (ReceiptViewerDialog
// today, potentially a general image/doc/PDF viewer later) knows which endpoint to call for the
// full-size view instead of always assuming Office Expense Receipts. Add new sources here as the
// viewer grows to support more document kinds.
enum DocumentSourceType {
    OfficeExpenseReceipt = 1,
    TimeExpenseReceipt = 2,
}

export default DocumentSourceType;



// WEBPACK FOOTER //
// ./src/components/project-billing/models/DocumentSourceType.ts